import { render, staticRenderFns } from "./mainFooter.vue?vue&type=template&id=35a3da8f&scoped=true&"
import script from "./mainFooter.vue?vue&type=script&lang=js&"
export * from "./mainFooter.vue?vue&type=script&lang=js&"
import style0 from "./mainFooter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./mainFooter.vue?vue&type=style&index=1&id=35a3da8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a3da8f",
  null
  
)

export default component.exports